export const DocFlowResultTableCellName = {
  Building: 'building',
  EmailAddress: 'email_address',
  EmailCreatedAt: 'email_created_at',
  EmailStatus: 'email_status',
  EpostError: 'epost_error',
  EpostSentAt: 'epost_sent_at',
  EpostSpentCredits: 'epost_spent_credits',
  EpostStatus: 'epost_status',
  EpostStatusTimeline: 'epost_status_timeline',
  File: 'file',
  Flat: 'flat',
  Recipient: 'recipient',
  RegisteredLetter: 'epost_registered_letter',
  Role: 'role',
  SavedToProfileAt: 'saved_to_profile_at',
  SavedToProfileDirectoryId: 'saved_to_profile_directory_id',
  SavedToProfileStatus: 'saved_to_profile_status',
}

export const DOC_FLOW_RESULT_TABLE_FILTER_STATE_URL = `/idwell-api/api/v3/table/filter-states/document-stapling-results/all/`

export const DOC_FLOW_RESULT_TABLE_CONFIG_URL = `/idwell-api/api/v3/table/tables/document-stapling-results/`
